import { RETURN_HOST_COOKIES } from "@/src/lib/alternate-host";
import { ROOT_DOMAIN } from "@/src/lib/preview-env";

export function resolveSameOriginRedirect(redirect: string | null | undefined, tenantUrl: URL): URL | null {
  if (!redirect) {
    return null;
  }

  try {
    const destinationUrl = new URL(redirect, tenantUrl);

    return destinationUrl.origin === tenantUrl.origin ? destinationUrl : null;
  } catch {
    return null;
  }
}

/** Reads a single-use return-host cookie, clearing it before the value is validated. */
function takeReturnHostCookie(name: string): string | undefined {
  const value = document.cookie
    .split("; ")
    .find((c) => c.startsWith(`${name}=`))
    ?.slice(name.length + 1);

  if (value) {
    document.cookie = `${name}=; domain=${ROOT_DOMAIN}; path=/; max-age=0`;
  }

  return value;
}

/**
 * Returns the alternate host the proxy stashed before sending the user to login, if any.
 * Every return-host cookie is cleared whichever one wins, since each is single-use.
 */
export function takeReturnHost(): string | null {
  let returnHost: string | null = null;

  for (const { cookie, pattern } of RETURN_HOST_COOKIES) {
    const value = takeReturnHostCookie(cookie);

    if (!returnHost && value && pattern.test(value)) {
      returnHost = value;
    }
  }

  return returnHost;
}

/** Writes the Stytch session cookie for the root domain and navigates to `destination`. */
export function persistSessionAndRedirect(sessionJwt: string, destination: URL): void {
  // The Stytch SDK persists the session cookie asynchronously, which can lose the race against this
  // navigation and leave the destination's first request carrying the previous tenant's cookie.
  const domainAttribute = window.location.hostname.endsWith(ROOT_DOMAIN) ? `; domain=${ROOT_DOMAIN}` : "";

  document.cookie = `stytch_session_jwt=${sessionJwt}${domainAttribute}; path=/; secure; samesite=lax`;

  window.location.replace(destination);
}
